<script lang="ts" setup>
  import type { IFooterAward } from '@/components/main-footer/types'

  const { isDesktop } = useBTBreakpoints()

  defineProps<{
    award: IFooterAward
  }>()

  const imageSizes = computed(() => {
    if (isDesktop.value) {
      return '93'
    }
    return '64'
  })
</script>

<template>
  <div
    class="grid min-w-52 max-w-64 grid-flow-col grid-cols-[64px_1fr] items-center gap-8 md:max-w-80 md:grid-cols-[88px_1fr]"
  >
    <div class="flex w-full max-w-16 justify-center md:max-w-22">
      <NuxtImg
        provider="storyblok"
        :src="award.src"
        :alt="award.alt"
        loading="lazy"
        :height="imageSizes"
      />
    </div>
    <span class="text-body-3">{{ award.title }}</span>
  </div>
</template>
